import * as React from 'react';
import { mapGridColPropsToCssClasses } from '../grid-col/component';
import { Tag } from '../types';
export function GridStandaloneCol(props) {
    const { children, className, shiftLeft, tag: Element = Tag.DIV } = props;
    const finalClassName = mapGridColPropsToCssClasses({
        props,
        postfix: `-sa`,
        additionalClasses: [].concat(className ? [className] : [], shiftLeft ? ['grid-col-sa-sl'] : []),
    });
    return React.createElement(Element, { className: finalClassName }, children);
}
//# sourceMappingURL=component.js.map